import MobileList from './MobileList';

export default MobileList;
